<template>
	<div class="hotel-detail-wrapper">
		<div class="swiper-wrapper" v-show="detailData.image&&detailData.image.length>0||(detailData.video&&detailData.video.url)">
			<van-swipe ref="s_b" class="swiper-container" :show-indicators="false" :width="swipeWidth" @change="onSwipeChange">
				<van-swipe-item v-if="detailData.video&&detailData.video.url"  id="J_prismPlayer" class="blur-wrapper">
				</van-swipe-item>
				<van-swipe-item v-for="(image,index) in detailData.image" :key="index">
					<img :src="`${image.url}?x-oss-process=image/resize,w_${swipeWidth}`" />
				</van-swipe-item>
                <template slot="indicator" v-if="!needshowVideo||!(detailData.video&&detailData.video.url)">
                    <div class="custom-indicator">{{ (detailData.video&&detailData.video.url)?currentSwipe:currentSwipe+1 }}/{{detailData.image&&detailData.image.length}}</div>
				</template>
			</van-swipe>
            <div class="change-btn-wrapper"  v-show="detailData.video&&detailData.video.url">
                <div class="change-btn">
                    <span class="video-btn" :class="needshowVideo?'active-btn':'deactive-btn'" @click.stop="showVideo">视频</span>
                    <span class="pic-btn"   :class="!needshowVideo?'active-btn':'deactive-btn'" @click.stop="showPic">图片</span>
                </div>
			</div>
		</div>
		<div class="detail-wrapper">
			<div class="title-text">
				<span class="text-wrapper">
					<span v-text="detailData.name" class="title"></span>
				</span>
			</div>
			<div class="tags">
				<div class="tag" v-for="(tag,i) of detailData.tags" :key="i" v-text="tag" v-show="tag!=''"></div>
			</div>
			<div class="address">
				<div>
					<img class="address-icon" :src="addressIcon">
					<span class="detail-address" v-text="detailData.address"></span>
				</div>
				<div class="forward" @click.stop="openMap">
					<span class="detail-map">地图</span>
					<img class="map-icon" :src="forwardIcon">
				</div>
			</div>
			<div class="tel">
				<img class="tel-icon" :src="telIcon">
				<a :href="'tel:'+detailData.tel" class="telephone">{{detailData.tel}}</a>
			</div>
		</div>

		<div class="comment-row" v-if="detailData.score">
			<span class="rate-row">
				<div class="rate">
					<span class="num" v-text="detailData.score || 0"></span>
					<star-orange :score="detailData.score"></star-orange>
				</div>
				<div>
					<span class="comment" @click.stop="redirectToComment(detailData.assess)">
						<span class="num" v-text="detailData.assess || 0"></span>
						<span>条评论</span>
					</span>
					<img class="right-icon" :src="rightIconSrc" alt="right-icon">
				</div>
			</span>
			<div class="first-comment" v-if="detailData.commentNum>0">
				<div class="flex-wra">
					<img :src="firstComment.profile || defaultUser.avatar" alt="avatar-image" class="avatar">
					<div class="mid-lane">
						<div class="user-name text-overflow" v-text="firstComment.userName || defaultUser.name"></div>
						<!-- <div class="date" v-text="firstComment.commentTime"></div> -->
					</div>
				</div>
				<div class="content" v-text="firstComment.content"></div>
			</div>
		</div>

		<div ref="slide">
			<div class="hotel-detail-title" :style="style">
				<div class="room" @click="roomFlagT">
					<span :class="roomFlag?'activated':''" ref="roomTitle">选择房型</span>
					<div :style="bottomStyle" :class="roomFlag?'bottom-style':''"></div>
				</div>
				<div class="overview" @click="roomFlagF">
					<span :class="roomFlag?'':'activated'">酒店详情</span>
					<div :style="bottomStyle" :class="roomFlag?'':'bottom-style'"></div>
				</div>
			</div>
			<div class="hotel-detail-title-add" v-show="styleFlag"></div>

			<div v-show="roomFlag" class="room-wrapper">
				<div class="date-card" @click="openCalendar">
					<div class="left">
						<div class="arr">
							<p>入住时间</p>
							<p class="in-date" v-text="arriveDateFormat"></p>
						</div>
					</div>
					<div class="middle">
						<span>共</span>
						<span v-text="durationDay"></span>
						<span>晚</span>
					</div>
					<div class="right">
						<div class="lea">
							<p>离店时间</p>
							<p class="in-date" v-text="leaveDateFormat"></p>
						</div>
					</div>
				</div>

				<template v-if="list.length > 0">
					<div
						class="each-room"
						v-for="(item,index) of list"
						:key="index"
						@click.stop="openRoomModal(item)"
					>
						<img
							:src="item.detail.thumbnail"
							@error="__change__no__image"
							class="scene-img img-responsive"
						>
						<div class="title-room">
							<div class="title-text">
								<span>
									<span v-text="item.roomName" class="title"></span>
								</span>
							</div>
							<div class="type-intro">
								查看
								<img :src="rightIconWhiteSrc" alt="right-icon">
							</div>
						</div>
						<div class="tags-room">
							<div class="tag" v-for="(tag,i) of createTags(item.detail)" :key="i" v-text="tag"></div>
						</div>
						<div class="hotel-detail-footer">
							<div class="price-btn">
								<span class="suffix">￥</span>
								<span class="num" v-text="item.salePrice"></span>
							</div>
							<div class="buy" @click.stop="goToOrder(item.id)">
								<span>预订</span>
							</div>
						</div>
					</div>
				</template>

				<template v-else>
					<div class="no-room-wra">
						<p class="no-room-text">您选择的日期内暂时没有适合的房型，您也可以</p>
						<div class="no-room-btn" @click="openCalendar">修改入离日期</div>
					</div>
				</template>
			</div>
		</div>

		<div v-show="!roomFlag">
			<div class="hotel-info-wrapper">
				<div class="service-item-wra">
					<div class="title" v-if="serviceItems.length>0">服务设施</div>
					<div class="item-card-wrapper" :class="{more:!viewMore}" v-if="serviceItems.length>0">
						<div class="each-item" v-for="(item,index) in serviceItems" :key="index">
							<img :src="facilitySrc(index,item.url)" class="service-image">
							<span class="service-title" v-text="item.label"></span>
							<!-- <span
                                v-text="(index===7&&viewMore)?'查看更多':item.label"
                                :class="{more:index===7&&viewMore}"
							></span>-->
						</div>
					</div>
				</div>
				<div class="each-block" v-if="hotelInfo.address">
					<div class="title">酒店地址</div>
					<div class="content" @click.stop="openMap">
						<img class="location" :src="addressIcon" alt>
						<span v-text="hotelInfo.address"></span>
					</div>
				</div>

				<div class="each-block" v-if="hotelInfo.tel">
					<div class="title">联系电话</div>
					<div class="content">
						<a class="tel" :href="'tel:'+hotelInfo.tel" v-text="hotelInfo.tel"></a>
					</div>
				</div>

				<div class="each-block" v-if="hotelInfo.traffic">
					<div class="title">交通信息</div>
					<div class="content">
						<span v-text="hotelInfo.traffic"></span>
					</div>
				</div>

				<div class="each-block" v-if="hotelInfo.introduction">
					<div class="title">详情介绍</div>
					<div class="rich-context-wra protect-image" v-html="hotelInfo.introduction"></div>
				</div>
			</div>
		</div>
		<room-intro-modal :item="currentItem" ref="modal" :is-show-bottom="true"></room-intro-modal>
		<select-range-date
			ref="datemodal"
			@confirm="changeRangeDate"
			:arrive="arriveDateFormat"
			:leave="leaveDateFormat"
			:duration="durationDay"
		></select-range-date>
        <page-guide v-show="showPageGuide"></page-guide>
	</div>
</template>

<script>
import RoomIntroModal from "@/components/RoomIntroModal";
import SelectRangeDate from "@/components/common/SelectRangeDate";
import StarOrange from "@/components/common/StarOrange";
import PageGuide from "@/components/common/PageGuide";
const FA = [
	{ label: "吧台", value: "1", url: "bar.png" },
	{ label: "冰箱", value: "2", url: "fridge.png" },
	{ label: "餐厅", value: "3", url: "restaurant.png" },
	{ label: "残疾人设施", value: "4", url: "disabledfacility.png" },
	{ label: "宠物允许", value: "5", url: "petallowed.png" },
	{ label: "吹风机", value: "6", url: "blower.png" },
	{ label: "电视", value: "7", url: "tv.png" },
	{ label: "健身房", value: "8", url: "gym.png" },
	{ label: "叫醒服务", value: "9", url: "wakeup.png" },
	{ label: "接待", value: "10", url: "reception.png" },
	{ label: "接送服务", value: "11", url: "pickup.png" },
	{ label: "空调", value: "12", url: "airconditioner.png" },
	{ label: "跑步机", value: "13", url: "treadmill.png" },
	{ label: "清洁服务", value: "14", url: "cleaning.png" },
	{ label: "热水洗浴", value: "15", url: "hotwater.png" },
	{ label: "停车场", value: "16", url: "parking.png" },
	{ label: "无线上网", value: "17", url: "wifi.png" },
	{ label: "西餐", value: "18", url: "western.png" },
	{ label: "洗衣机", value: "19", url: "washer.png" },
	{ label: "哑铃", value: "20", url: "dumbbell.png" },
	{ label: "泳池", value: "21", url: "pool.png" },
	{ label: "有线上网", value: "22", url: "internet.png" },
	{ label: "熨斗", value: "23", url: "iron.png" },
	{ label: "其他", value: "24", url: "other.png" }
];

export default {
	name: "HotelDetail",
	components: { RoomIntroModal, SelectRangeDate, StarOrange ,PageGuide },
	props: {
		// layouts: String,
		// layoutType: String,
	},
	data() {
		return {
            defaultUser: {
                avatar: API.ossUrl + "common/empty_icons/noimage-1-1.png?param=1",
                name: "未知用户"
            },
			currentSwipe: 0,
			arriveDate: moment(),
			leaveDate: moment().add(1, "day"),
			detailData: {},
			currentItem: {},
			swipeWidth: window.innerWidth,
			addressIcon: "",
			telIcon: "",
			forwardIcon: "",
			roomFlag: true,
			viewMore: true,
			hotelInfo: {},
			isWXSharePage: true,
			rightIconSrc: "",
			rightIconGreenSrc: "",
			facilityUrl: "",
			style: "",
			styleFlag: false,
            bottomStyle: "",
            showPageGuide: true,
            currentSwipe: 0,
            needshowVideo:  true,
            showVideoImg: true,
            player: null,
		};
	},
	computed: {
		ossResolvedAvatar() {
			if (!this.firstComment.profile || this.firstComment.profile === "0")
				return "";
			return (
				`${
					this.firstComment.profile
				}?x-oss-process=image/resize,h_300` || ""
			);
		},
		firstComment() {
			return this.detailData.comment ? this.detailData.comment[0] : {};
		},
		durationDay() {
			const range = moment.range(this.arriveDate, this.leaveDate);
			const days = range.diff("day");
			return days;
		},
		arriveDateFormat() {
			return this.arriveDate.format("MM月DD日");
		},
		leaveDateFormat() {
			return this.leaveDate.format("MM月DD日");
		},
		list() {
			return this.detailData.list || [];
		},
		tagsWithLevel() {
			let level = ["无", "一", "二", "三", "四", "五", "六", "七"];
			if (this.detailData.tags) {
				return [
					level[this.detailData.level] + "星级",
					...this.detailData.tags
				];
			} else {
				return [];
			}
		},
		serviceItems() {
			let { facilities } = this.hotelInfo;
			if (Array.isArray(facilities) && facilities.length > 0) {
				return facilities.map(e => {
					return FA.find(fa => fa.value === e);
				});
			} else {
				return [];
			}
		}
	},
	watch: {},
	activated() {
		this.roomFlag = true;
		this.isWXSharePage = true;
		this.currentSwipe = 0;
		if (sessionStorage.arriveDateString) {
			this.arriveDate = moment(sessionStorage.arriveDateString);
			this.leaveDate = moment(sessionStorage.leaveDateString);
		}
		this.storeDates();
		this.getHotelDetailData();
		this.goToTop();
	},
	// created(){
	//     this.roomFlag = true;
	//     this.isWXSharePage = true;
	//     this.currentSwipe = 0;
	//     if (sessionStorage.arriveDateString) {
	//         this.arriveDate = moment(sessionStorage.arriveDateString);
	//         this.leaveDate = moment(sessionStorage.leaveDateString);
	//     }
	//     this.storeDates();
	//     this.getHotelDetailData();
	// },
	deactivated() {
		this.isWXSharePage = false;
		this.$refs.modal.closeModal();
        this.$refs.datemodal.closeModal();
        this.detailData = {};
        this.currentSwipe = 0;
        if(this.player){
            this.player.dispose();
            this.player = null;
        }
	},
	beforeDestroy() {},
	mounted() {
		this.bottomStyle = `width:${
			this.$refs.roomTitle.offsetWidth
		}px;position:relative;left:${this.$refs.roomTitle.getBoundingClientRect()
			.left - 10}px;`;
		this.addressIcon = API.ossUrl + "scene/png/address-icon.png";
		this.telIcon = API.ossUrl + "common/phone-icon.png";
		this.forwardIcon = API.ossUrl + "common/forward.png";
		this.rightIconSrc = API.ossUrl + "home/png/gray-right-arrow.png";
		this.rightIconWhiteSrc = API.ossUrl + "hotel/png/right-icon-white.png";
		this.locationIconSrc = API.ossUrl + "scene/png/location-icon.png";
		this.menu();
		this.goToTop();
	},
	beforeRouteLeave(to, from, next) {
		//回到列表页前清除掉存储的日期
		if (to.name == "hotel") {
			sessionStorage.removeItem("arriveDateString");
			sessionStorage.removeItem("leaveDateString");
			sessionStorage.removeItem("durationDay");
		}
		next();
	},
	destroyed() {
		// this.goToTop();
	},
	methods: {
        showVideo(){
            this.needshowVideo = true;
            this.$refs.s_b.swipeTo(0);
        },
        showPic(){
            this.needshowVideo = false;
            this.$refs.s_b.swipeTo(1);
        },
		onSwipeChange(index) {
            this.currentSwipe = index;
            this.currentSwipe == 0 ? this.needshowVideo = true: this.needshowVideo = false;
            this.currentSwipe == 0 ? this.showVideoImg = true: false;
            if(this.currentSwipe != 0&&this.player){
                this.player.pause();
            } 
		},
		menu() {
			window.scrollTo(0, 0);
		},
		goToTop() {
			let vm = this;
			window.onscroll = function() {
				if (sessionStorage.getItem("onscroll") !== "hotelDetail") {
					vm.style = {};
					return;
				}
                var div = vm.$refs.slide;
                if(!div){
                    return;
                }
				if (div.getBoundingClientRect().top <= 10) {
					vm.style = {
						position: "fixed",
						top: 0,
						"background-color": "#fff",
						"z-index": 100,
						width: "100%",
						"margin-left": "-1px"
					};
					vm.styleFlag = true;
				} else {
					vm.style = {};
					vm.styleFlag = false;
				}
			};
		},
		roomFlagT() {
			if (this.roomFlag) {
				return;
			}
			this.roomFlag = true;
			let rect = this.$refs.slide.getBoundingClientRect();
			let scrollTop =
				document.documentElement.scrollTop ||
				document.body.scrollTop ||
				window.pageYOffset;
			let clientTop =
				document.documentElement.clientTop || document.body.clientTop;
			let height = rect.top - clientTop + scrollTop - 10;
			window.scrollTo({ top: height, behavior: "smooth" });
		},
		roomFlagF() {
			if (!this.roomFlag) {
				return;
			}
			this.roomFlag = false;
			let rect = this.$refs.slide.getBoundingClientRect();
			let scrollTop =
				document.documentElement.scrollTop ||
				document.body.scrollTop ||
				window.pageYOffset;
			let clientTop =
				document.documentElement.clientTop || document.body.clientTop;
			let height = rect.top - clientTop + scrollTop - 10;
			window.scrollTo({ top: height, behavior: "smooth" });
		},
		openMap() {
			UTILS.openMap(this.hotelInfo);
		},
		triggerMore() {
			this.viewMore = !this.viewMore;
		},
		storeDates() {
			sessionStorage.arriveDateString = this.arriveDate.format(
				"YYYY-MM-DD"
			);
			sessionStorage.leaveDateString = this.leaveDate.format(
				"YYYY-MM-DD"
			);
			sessionStorage.durationDay = this.durationDay;
		},
		createTags(item) {
			let res = [];
			[
				"bedTypeName",
				"breakfastName",
				"hasWindowName",
				"wifiName"
			].forEach(name => {
				if (item.hasOwnProperty(name) && "" != item[name]) {
					res.push(item[name]);
				}
			});
			return res;
		},
		openMap() {
			UTILS.openMap(this.detailData);
		},
		openRoomModal(item) {
			this.currentItem = item;
			this.$nextTick(() => {
				this.$refs.modal.openModal();
				window.removeEventListener("scroll", this.goToTop);
			});
		},
		closeModal() {
			this.$refs.modal.closeModal();
		},
		redirectToHotelInfo() {
			this.$router.push({
				name: "hotelInfo",
				params: { hotelId: this.$route.params.hotelId }
			});
		},
		redirectToComment(value) {
			if (value < 1) {
				return;
			}
			this.$router.push({
				name: "hotelComment",
				params: { hotelId: this.$route.params.hotelId }
			});
		},
		goToOrder(roomId) {
			this.$router.push({
				name: "roomOrder",
				params: {
					roomId
				}
			});
		},
		openCalendar() {
            this.$refs.datemodal.openModal();
            this.showPageGuide = false;
		},
		hiddenTag() {
			let tagArray = [...document.querySelectorAll(".room-wrapper .tag")];
			let cw = document.body.clientWidth - 85;
			tagArray.forEach(element => {
				if (element.getBoundingClientRect().right > cw) {
					element.style.visibility = "hidden";
				}
			});
		},
		getHotelDetailData() {
			let dateRange =
				this.arriveDate.format("YYYY-MM-DD") +
				"," +
				this.leaveDate.format("YYYY-MM-DD");
			// let dateRange ="2018-11-23,2018-11-25";
			this.$axios
				.get(
					`${window.API.hotel.detail}/${
						this.$route.params.hotelId
					}/${encodeURIComponent(dateRange)}`
				)
				.then(({ data }) => {
					if (data.code == 200) {
                        this.detailData = data.data;
                        if(this.detailData.video&&this.detailData.video.url){
                            let videoUrl = this.detailData.video.url;
                            let coverImg = `${this.detailData.video.url}?x-oss-process=video/snapshot,t_2000,f_jpg,w_500,h_300` 
                            this.$nextTick(()=>{ 
                                this.player = new Aliplayer({
                                    id: "J_prismPlayer", // 容器id
                                    source: videoUrl,  //视频地址
                                    cover: coverImg,  //播放器封面图
                                    autoplay: false,      // 是否自动播放
                                    width: "100%",       // 播放器宽度
                                    height: "400px",      // 播放器高度
                                    playsinline: true,
                                    seekable: true,
                                    skinLayout: [{
                                        "name": "bigPlayButton",
                                        "align": "cc"
                                        //"x": 30,
                                        //"y": 80
                                    }, {
                                        "align": "blabs",
                                        "x": 0,
                                        "y": 10,
                                        "name": "controlBar",
                                        "children": [
                                        {
                                            "align": "tl",
                                            "x": 15,
                                            "y": 26,
                                            "name": "playButton"
                                        }, {
                                            "align": "tl",
                                            "x": 10,
                                            "y": 24,
                                            "name": "timeDisplay"
                                        }, {
                                            "align": "tr",
                                            "x": 20,
                                            "y": 25,
                                            "name": "fullScreenButton"
                                        }, {
                                            "align": "tr",
                                            "x": 20,
                                            "y": 25,
                                            "name": "volume"
                                        },
                                        {
                                            "name": "progress",
                                            "align": "tlabs",
                                            "x": 0,
                                            "y": 0
                                        }
                                        ]
                                    }]
                                })
                            })
                        }
						// sessionStorage.hotelInfo = JSON.stringify(data.data);
						let levelArr = ["一", "二", "三", "四", "五"];
						let index = this.detailData.level - 1;
						let levelContent = levelArr[index];
						if (this.detailData.level > 0) {
							this.detailData.tags.unshift(levelContent + "星级");
						}

						this.hotelInfo = data.data;
						let temp = [];
						for (
							let i = 0;
							i < this.hotelInfo.facilities.length;
							i++
						) {
							if (this.hotelInfo.facilities[i] != 22) {
								temp.push(this.hotelInfo.facilities[i]);
							}
						}
						this.viewMore = this.hotelInfo.facilities.length > 7;
						this.$nextTick(this.hiddenTag);
						//设置微信分享
						if (
							this.isWXSharePage &&
							sessionStorage.getItem("title") !==
								`${API.projectName}-${data.data.name}`
						) {
							this.isWXSharePage = false;
							window.global.getConfig({
								title: `${API.projectName}-${data.data.name}`,
								link: `${window.location.origin}?shareto=${
									this.$route.name
								}&shareid=${this.$route.params.hotelId}`,
								imgUrl: `${
									data.data.image[0]
										? data.data.image[0].url +
										  "?x-oss-process=image/resize,m_fill,h_256,w_256"
										: ""
								}`,
								desc: ``
							});
						}
					} else {
						this.$toast(data.msg);
					}
				})
				.catch(err => console.log(err));
		},
		changeRangeDate({ arriveDate, leaveDate }) {
			this.arriveDate = moment(arriveDate);
			this.leaveDate = moment(leaveDate);
			this.storeDates();
            this.getHotelDetailData();
            this.showPageGuide = true;
		},
		facilitySrc(index, url) {
			return API.ossUrl + "hotel/png/facility/" + url;
		}
	}
};
</script>

<style scoped lang="scss">
.hotel-detail-wrapper {
	background: #ffffff;
	.swiper-wrapper {
        height: 5.013333rem;
        .change-btn-wrapper {
			position: absolute;
			top: 4rem;
            left: 0;
			width: 100%;
			z-index: 100;
            .change-btn{
                display: flex;
                align-items: center;
                justify-content: center;
            }
			.video-btn,
			.pic-btn {
				display: inline-block;
                line-height: 0.586667rem;
                font-size:0.293333rem;
				border-radius: 0.373333rem;
                text-align: center;
			}
            .video-btn{
                margin-right: 0.266667rem;
            }
            .active-btn{
                width:1.493333rem;
                height:0.586667rem;
                border: none;
                color: #ffffff;
                background: #ffbc00;
            }
            .deactive-btn{
                width: 1.44rem;
				height: 0.586667rem;
                background:rgba(255,255,255,1);
                border:0.026667rem solid rgba(202,202,202,0.8);
            }
		}
		.swiper-container {
            height: 100%;
            .blur-wrapper {
                position: relative;
                .video-play {
                    position: absolute;
                    top: 1.466667rem;
                    left: 4.373333rem;
                    z-index: 100;
                    width: 1.28rem;
                    height: 1.28rem;
                }
            }
		}
	}
	.detail-wrapper {
		padding: 0.2667rem 0 0 0.2667rem;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 4px 4px rgba(174, 174, 174, 0.28);
		border-radius: 10px;
		top: 0rem;
		margin: 0.5333rem;
		width: 8.9333rem;
		z-index: 20;
		position: relative;
		.title-text {
			display: flex;
			justify-content: space-between;
			align-items: baseline;
			margin-bottom: 0.32rem;
			.text-wrapper {
				display: flex;
				align-items: baseline;
				padding-right: 0.1867rem;
			}
			.title {
				font-family: PingFangSC-Medium;
				font-weight: bold;
				color: rgba(68, 68, 68, 1);
				line-height: 0.6667rem;
				font-size: 0.48rem;
			}
			.star-tag {
				width: 0.746667rem;
				height: 0.4rem;
				line-height: 0.4rem;
				text-align: center;
				background: $blue;
				border-radius: 2px;
				color: $white;
				margin-left: 0.346667rem;
				font-size: 0.293333rem;
			}
		}
		.tags {
			width: 100%;
			display: flex;
			margin-bottom: 0.3467rem;
			flex-wrap: wrap;
			.tag {
				display: flex;
				align-items: center;
				padding: 0.045rem 0.16rem;
				border: 1px solid rgba(77, 77, 174, 1);
				font-family: PingFangSC-Regular;
				font-weight: 400;
				color: #4d4dae;
				background: transparent;
				margin-bottom: 0.14rem;
				margin-right: 0.2667rem;
				font-size: 0.32rem;
				border-radius: 0.266667rem;
				flex: 0 0 auto;
				border-radius: 0.16rem;
				line-height: 0.453333rem;
				&:last-child {
					margin-right: 0;
				}
			}
		}
		.address {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			width: 100%;
			// margin-bottom: 0.2667rem;
			div {
				display: flex;
				align-items: flex-start;
				.address-icon {
					display: inline-block;
					height: 0.373333rem;
					width: 0.373333rem;
					margin-right: 0.106667rem;
					position: relative;
					top: 0.026667rem;
				}
				.detail-address {
					width: 7.033333rem;
					font-size: 0.3733rem;
					font-family: PingFangSC-Regular;
					font-weight: 400;
					color: #444444;
					line-height: 0.533333rem;
					display: inline-block;
				}
			}
			.forward {
				width: 22%;
				.detail-map {
					font-family: PingFangSC-Regular;
					font-weight: 400;
					color: rgba(140, 140, 140, 1);
					font-size: 0.373333rem;
					line-height: 0.533333rem;
				}
				.map-icon {
					width: 0.373333rem;
					height: 0.373333rem;
					margin-right: 0.16rem;
					position: relative;
					display: inline-block;
					margin-top: 1px;
				}
			}
		}
		.tel {
			display: flex;
			width: 100%;
			margin: 0.32rem 0 0;
			padding-bottom: 0.2667rem;
			.tel-icon {
				height: 0.3733rem;
				width: 0.3733rem;
				margin-right: 0.106667rem;
				position: relative;
				top: 2px;
			}
			.telephone {
				height: 0.5333rem;
				font-size: 0.3733rem;
				font-family: PingFangSC-Semibold;
				font-weight: bold;
				color: #f0bb1b;
				line-height: 0.5333rem;
				text-decoration: none;
			}
		}
	}
	.comment-row {
		display: flex;
		flex-direction: column;
		// padding-top: 0.28rem;
		padding-bottom: 0.28rem;
		.title {
			color: #404040;
			font-weight: bold;
			font-size: 0.426667rem;
		}
		.rate-row {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-left: 0.4rem;
			// width: 100%;
			.rate {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				width: 2.666667rem;
				padding-right: 0.2rem;
				width: 60%;
				span {
					font-size: 0.32rem;
					color: $orange;
					margin-right: 0.186667rem;
				}
				.num {
					font-size: 26px;
					// font-weight: bold;
					line-height: 0.986667rem;
				}
			}
			.comment {
				display: inline-block;
				padding-left: 0.2rem;
				span {
					font-size: 0.373333rem;
					color: #b3b3b3;
				}
				// .num {
				//     color: $orange;
				// }
			}
			.right-icon {
				width: 0.32rem;
				margin: 0 0.32rem 0 0.173333rem;
				position: relative;
			}
		}
		.first-comment {
			border-radius: 5px;
			margin-top: 0.106667rem;
			margin-left: 0.426667rem;
			.flex-wra {
				margin-bottom: 0.266667rem;
				display: flex;
				flex-wrap: nowrap;
				align-items: center;
				.avatar {
					width: 1.066667rem;
					height: 1.066667rem;
					border-radius: 50%;
					margin-right: 0.266667rem;
				}
				.mid-lane {
					flex: 1 0 auto;
					max-width: 5.8rem;
					.user-name {
						font-size: 0.373333rem;
						font-weight: 500;
						line-height: 1.066667rem;
						color: #444444;
					}
				}
			}
			.content {
				font-size: 0.373333rem;
				font-weight: 400;
				line-height: 0.533333rem;
				color: #444444;
				@include multiple-text-overflow(2);
			}
		}
	}
	.hotel-detail-title {
		padding: 0.2667rem;
		text-align: center;
		display: flex;
		.room,
		.overview {
			flex: 1;
			font-size: 0.426667rem;
			font-weight: 400;
			color: rgba(68, 68, 68, 1);
			line-height: 0.586667rem;
			.activated {
				font-family: PingFangSC-Medium;
				font-weight: bold;
				padding-bottom: 0.106667rem;
			}
			.bottom-style {
				height: 2px;
				margin-top: 4px;
				background: rgba(240, 187, 27, 1);
				box-shadow: 0px 0px 4px 0px rgba(241, 188, 0, 0.6);
			}
		}
	}
	.hotel-detail-title-add {
		height: 0.2933rem;
	}
	.room-wrapper {
		background: $white;
		padding: 0.266667rem 0.266667rem 7.333333rem 0.266667rem;
		margin-top: 0.213333rem;
		min-height: 17.7867rem;
		.date-card {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			padding: 0.266667rem 0.346667rem;
			background: rgba(255, 255, 255, 1);
			box-shadow: 0px 0px 4px 2px rgba(167, 167, 167, 0.2);
			border-radius: 10px;
			.left {
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				p {
					font-size: 0.373333rem;
					font-family: PingFangSC-Regular;
					color: #444444;
				}
				.in-date {
					margin-top: 0.16rem;
					font-weight: bold;
					color: #f8b356;
					font-size: 0.533333rem;
					line-height: 0.746667rem;
				}
			}
			.middle {
				font-size: 0.373333rem;
				font-weight: 400;
				line-height: 0.533333rem;
				box-shadow: 0px 0px 3px 2px rgba(167, 167, 167, 0.2);
				border-radius: 0.32rem;
				padding: 0.053333rem 0.266667rem;
			}
			.right {
				.lea {
					width: 100%;
					p {
						min-width: 1.493333rem;
						font-size: 0.3733rem;
						color: #444444;
						margin-left: 0.773333rem;
					}
					.in-date {
						width: 100%;
						margin-top: 0.16rem;
						font-weight: bold;
						color: #f8b356;
						font-size: 0.533333rem;
						line-height: 0.746667rem;
						margin-left: 0;
					}
				}
			}
		}
		.each-room {
			padding: 0.4rem 0;
			&:last-child {
				border-bottom: 0;
			}
			&:first-child {
				margin-top: 0.266667rem;
			}
			.scene-img {
				border-radius: 10px;
				height: 4.48rem;
			}
			.title-room {
				display: flex;
				justify-content: space-between;
				position: relative;
				top: -0.8rem;
				.title-text {
					margin-left: 0.4rem;
					font-family: PingFangSC-Medium;
					font-weight: 500;
					color: #ffffff;
					font-size: 18px;
				}
				.type-intro {
					margin-right: 0.4rem;
					font-family: PingFangSC-Regular;
					font-weight: 400;
					color: #ffffff;
					font-size: 0.373333rem;
					img {
						width: 0.213333rem;
						height: 0.2667rem;
						position: relative;
					}
				}
			}
			.tags-room {
				display: flex;
				justify-content: flex-start;
				margin-top: -0.4rem;
				.tag {
					border-radius: 0.16rem;
					border: 1px solid #4d4dae;
					font-family: PingFangSC-Regular;
					font-weight: 400;
					color: #4d4dae;
					font-size: 0.32rem;
					margin-right: 0.266667rem;
					line-height: 0.453333rem;
					padding: 0 0.16rem;
				}
			}
			.hotel-detail-footer {
				display: flex;
				justify-content: space-between;
				margin-top: 0.133333rem;
				align-items: flex-end;
				.price-btn {
					width: 1.84rem;
					height: 0.773333rem;
					color: $white;
					align-self: center;
					font-family: PingFangSC-Semibold;
					font-weight: 600;
					color: rgba(255, 146, 0, 1);
					border-radius: 0.386667rem;
					text-align: center;
					display: flex;
					justify-content: center;
					.suffix {
						font-size: 0.48rem;
						font-weight: bold;
						display: inline-block;
						// vertical-align: bottom;
						line-height: 1.093333rem;
					}
					.num {
						vertical-align: bottom;
						font-weight: bold;
						font-size: 0.693333rem;
						line-height: 0.986667rem;
					}
				}
				.buy {
					width: 1.866667rem;
					height: 0.96rem;
					background: linear-gradient(
						90deg,
						rgba(248, 199, 64, 1) 0%,
						rgba(245, 149, 38, 1) 100%
					);
					border-radius: 0.48rem;
					text-align: center;
					display: flex;
					justify-content: center;
					align-items: center;
					span {
						font-size: 0.426667rem;
						font-family: PingFangSC;
						font-weight: 600;
						color: rgba(255, 255, 255, 1);
					}
				}
			}
		}
		.no-room-wra {
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-top: 1.2rem;
			.no-room-text {
				font-size: 0.373333rem;
				color: #999;
			}
			.no-room-btn {
				margin-top: 0.4rem;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 0.373333rem;
				color: $white;
				background: linear-gradient(
					90deg,
					rgba(248, 199, 64, 1) 0%,
					rgba(245, 149, 38, 1) 100%
				);
				border-radius: 5px;
				height: 0.85rem;
				width: 3.4rem;
			}
		}
	}
	.hotel-info-wrapper {
		min-height: 17.7867rem;
		background: $white;
		.service-item-wra {
			padding-top: 0.533333rem;
			.title {
				margin-left: 0.533333rem;
				font-weight: bold;
				font-size: 0.4rem;
			}
			.item-card-wrapper {
				width: 100%;
				border-radius: 10px;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				background: $white;
				padding: 0.533333rem 0 0.08rem 0.533333rem;
				overflow: hidden;
				transition: max-height 0.3s;
				&.more {
					max-height: 13rem;
				}
				.each-item:nth-child(8):before {
					content: "";
					position: absolute;
					width: 100%;
					height: 100%;
					left: 0;
					top: 0;
					z-index: 100;
				}
				.each-item {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					text-align: center;
					width: 33%;
					position: relative;
					&:nth-child(n + 4) {
						margin-top: 0.533333rem;
					}
					.service-image {
						width: 0.533333rem;
						height: 0.533333rem;
						margin-right: 0.213333rem;
					}
					.service-title {
						font-size: 0.373333rem;
						font-family: PingFangSC-Regular;
						font-weight: 400;
						color: #444444;
						line-height: 0.533333rem;
					}
					span {
						color: $grey4;
						font-size: 0.32rem;
						// &.more {
						//     color: $blue;
						// }
					}
				}
			}
		}
		.each-block {
			padding-top: 0.533333rem;
			margin: 0 0.4rem;
			&:last-child {
				border-bottom: 0;
			}
			.title {
				margin-bottom: 0.4rem;
				color: #484848;
				font-weight: bold;
				font-size: 0.4rem;
			}
			.content {
				font-size: 0.373333rem;
				color: #808080;
				span {
					font-size: 0.373333rem;
					color: #808080;
				}
				.location {
					width: 0.32rem;
					height: 0.373333rem;
					vertical-align: middle;
					margin-right: 0.213333rem;
				}
				.tel {
					color: #808080;
				}
			}
		}
	}
}
</style>



